import { action } from 'typesafe-actions';
// Fetch translations
export const FETCH_TRANSLATIONS_REQUEST = '[Request] Fetch Translations';
export const FETCH_TRANSLATIONS_SUCCESS = '[Success] Fetch Translations';
export const FETCH_TRANSLATIONS_FAILURE = '[Failure] Fetch Translations';
export const fetchTranslationsRequest = (locale) => action(FETCH_TRANSLATIONS_REQUEST, { locale });
export const fetchTranslationsSuccess = (locale, translations) => action(FETCH_TRANSLATIONS_SUCCESS, { locale, translations });
export const fetchTranslationsFailure = (error) => action(FETCH_TRANSLATIONS_FAILURE, { error });
// Change locale
export const CHANGE_LOCALE = 'Change locale';
export const changeLocale = (locale) => action(CHANGE_LOCALE, { locale });
//# sourceMappingURL=actions.js.map